import styled from 'styled-components';

export const RadialMenuDiv = styled.div`
  width: 50%;

  @media (max-width: 500px) {
    height: 50%;
    width: 100%;
  }
`;
